<tr [ngClass]="cssClassName">
  <td easEditorBookingItemInheritableTypeHeader
    [inheritableType]="item.userCanBook() ? 'set' : 'empty'"
    i18n>
    User ability to book this option
  </td>
  <td>
    <ng-container *ngIf="item.userCanBook()">
      <ng-container i18n>User able to book onto this option</ng-container>
      <ng-container *ngIf="item.hideSpecificBookingSettingsIsEditable()">
        ({{ getSpecificBookingSettingsAdditionalInfo() }})
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!item.userCanBook()" i18n>User not booking onto this option</ng-container>
    <button mat-icon-button
      aria-label="Edit ability to book"
      i18n-aria-label
      (click)="onEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </td>
  <td>
  </td>
</tr>
